import { useState, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Flex,
  Box,
  Text,
  Button,
  I18NEdit,
  I18NCancel,
  H2,
  H3
} from '../../../components';
import * as messages from '../messages';
import { VerifyPhoneNumber } from '../../VerifyPhoneNumber';
import { CurrentUser, VerificationMode } from '../../../core-types';
import { useToasts } from '../../../components/Toasts';

function PhoneNumberForm({ currentUser }: { currentUser: CurrentUser }) {
  const [isEditing, setIsEditing] = useState(false);
  const { addToast } = useToasts();
  const { parsedPhoneNumber } = currentUser;

  let component;
  if (!isEditing) {
    component = (
      <Fragment>
        <Flex mb={2} alignItems="center">
          {parsedPhoneNumber && (
            <Box
              mr={2}
              itemProp="telephone"
              {...{
                content: `${parsedPhoneNumber.countryCode}${parsedPhoneNumber.nationalNumber}`
              }}
            >
              {parsedPhoneNumber.formattedNumber}
            </Box>
          )}
          <Button
            data-testid="PhoneNumberForm__EditButton"
            small
            shape="cool"
            onClick={() => setIsEditing(true)}
          >
            <I18NEdit />
          </Button>
        </Flex>
      </Fragment>
    );
  } else {
    component = (
      <Fragment>
        <H3 mb={4}>
          <FormattedMessage {...messages.phoneNumberForm.isEditing} />
        </H3>
        <Box mb={4} textAlign="left">
          <VerifyPhoneNumber
            initialValues={{ prefix: '', nationalPhoneNumber: '' }}
            mode={VerificationMode.update}
            additionalSendCodeButton={
              <Button variant="link" onClick={() => setIsEditing(false)}>
                <I18NCancel />
              </Button>
            }
            onPhoneNumberUpdate={() => {
              addToast({
                text: (
                  <FormattedMessage {...messages.phoneNumberForm.updated} />
                ),
                type: 'success'
              });
              setIsEditing(false);
            }}
          />
        </Box>
      </Fragment>
    );
  }
  return (
    <Fragment>
      <H2>
        <FormattedMessage {...messages.phoneNumberForm.heading} />
      </H2>
      <Text as="p">
        <FormattedMessage {...messages.phoneNumberForm.disclaimer} />
      </Text>
      {component}
    </Fragment>
  );
}

export default PhoneNumberForm;
